export const CHART_PANEL_IDS = [0, 1, 2, 3] as const;

export type ChartPanelId = (typeof CHART_PANEL_IDS)[number];

export function isChartPanelId(n: number): n is ChartPanelId {
  return n === 0 || n === 1 || n === 2 || n === 3;
}
